<template lang="pug">
b-modal(
  v-bind="$attrs"
  v-on="$listeners"
  :visible="visible"
  :header-class="headerClass"
  :footer-class="footerClass"
  :hide-footer="hideFooter"
)
  //- Pass through all slots
  template(v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope")
    slot(:name="slot" v-bind="scope")

  //- Custom Footer enforcement
  template(#modal-footer="{ ok, cancel, hide }")
    div.d-flex.justify-content-between.align-items-center.w-100
      slot(name="modal-footer" v-bind="{ ok, cancel, hide }")
        //- Left: Cancel / Secondary Action
        b-button.btn-samtek-secondary(
          :variant="cancelVariant"
          size="sm"
          @click="onCancel(hide)"
          class="mr-auto"
          :disabled="loading"
          :data-testid="cancelTestId"
        ) {{ cancelText }}

        //- Right: Confirm / Primary Action
        b-button.btn-samtek-primary(
          :variant="confirmVariant"
          size="sm"
          @click="onConfirm(ok)"
          :disabled="loading"
          :data-testid="confirmTestId"
        )
          b-spinner(v-if="loading" small class="mr-1")
          span {{ confirmText }}
</template>

<script>
export default {
  name: 'SamtekModal',
  inheritAttrs: false,
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancelar',
    },
    confirmText: {
      type: String,
      default: 'Aceptar',
    },
    cancelVariant: {
      type: String,
      default: 'light',
    },
    confirmVariant: {
      type: String,
      default: 'warning', // Bootstrap 'warning' is usually close to yellow, but we will use custom class too
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    headerClass: {
      type: String,
      default: '',
    },
    footerClass: {
      type: String,
      default: 'd-flex justify-content-between align-items-center w-100', // Enforce spacing
    },
    confirmTestId: {
      type: String,
      default: null,
    },
    cancelTestId: {
      type: String,
      default: null,
    },
  },
  methods: {
    onCancel(hideFn) {
      if (this.$listeners.cancel) {
        this.$emit('cancel', hideFn)
      } else {
        hideFn()
      }
    },
    onConfirm(okFn) {
      if (this.$listeners.confirm) {
        this.$emit('confirm', okFn) // Parent should handle logic and close manually if needed, or we just emit
      } else {
        // If just a simple confirmation is needed without custom logic
        this.$emit('ok')
        okFn()
      }
    },
  },
}
</script>

<style lang="scss">
/* Global style override for this component specifically if needed, 
   but ideally .btn-samtek-primary is global */
.btn-samtek-primary {
  background-color: #fece2f !important;
  color: #23201c !important;
  border-color: #fece2f !important;
  font-weight: 600;

  &:hover {
    background-color: darken(#fece2f, 10%) !important;
    border-color: darken(#fece2f, 10%) !important;
    color: #23201c !important;
  }
}

.btn-samtek-secondary {
  background-color: #f5f6fa !important;
  color: #707070 !important; /* Darker gray for text contrast */
  border-color: #f5f6fa !important;
  font-weight: 600;

  &:hover {
    background-color: darken(#f5f6fa, 5%) !important;
    border-color: darken(#f5f6fa, 5%) !important;
    color: #707070 !important;
  }
}
</style>
